export const getFullUrl = (path = '', subdomain) => {
  const protocol = window.location.protocol;
  let host = window.location.host || '';
  const wwwIndex = host.indexOf('www.');

  if (subdomain && wwwIndex !== -1) {
    host = `${subdomain}.${host.substring(wwwIndex + 4)}`;
  } else if (subdomain) {
    host = `${subdomain}.${host}`;
  }

  return `${protocol}//${host}${path}`;
};

const BRAND_NAMES = {
  shipsticks: 'Ship Sticks',
  shipplay: 'Ship Play',
  shipcamps: 'Ship Camps',
};

export const brandName = (brandId) => {
  if (!brandId) return 'Ship Sticks';
  return BRAND_NAMES[brandId.toLowerCase()] || 'Ship Sticks';
};
